export const generalKey = 'product_sp_400w_solar_panel';
export const whiteLocaleList = ['jp']; //白名单
export const productPageUrl = 'outdoor-campaign';
export const tabsValues = ['Product', 'Bundles'];
export const productPageTheme = 'white'; //主题色
